import { CSSProperties, forwardRef, HTMLAttributes, PropsWithChildren } from "react";

export interface FlexProps extends Omit<HTMLAttributes<HTMLDivElement>, "wrap"> {
  align?: CSSProperties["alignItems"];
  justify?: CSSProperties["justifyContent"];
  direction?: CSSProperties["flexDirection"];
  wrap?: true | CSSProperties["flexWrap"];
  gap?: CSSProperties["gap"];
  inline?: boolean;
}

export const Flex = forwardRef<HTMLDivElement, PropsWithChildren<FlexProps>>(
  ({ align, justify, direction, wrap, style, gap, inline, ...props }, ref) => {
    return (
      <div
        style={{
          display: inline ? "inline-flex" : "flex",
          justifyContent: justify,
          alignItems: align,
          flexDirection: direction,
          flexWrap: wrap === true ? "wrap" : wrap,
          gap,
          ...style,
        }}
        {...props}
        ref={ref}
      />
    );
  },
);
